import { InvoiceItem } from '@models/invoice/invoice-item.model';
import { getInvoiceItemCategoryFromValue } from '@models/types/invoice-item-category';
import { getInvoiceItemStatusFromValue } from '@models/types/invoice-item-status';

import { ApiAdapter } from './adapter';
import { InvoiceLabelAdapter } from './invoice-label.adapter';

export class InvoiceItemAdapter extends ApiAdapter<InvoiceItem> {
  private invoiceLabelAdapter = new InvoiceLabelAdapter();

  get(json): InvoiceItem {
    return new InvoiceItem({
      id: json['id'],
      category: getInvoiceItemCategoryFromValue(json['category']),
      unitPrice: json['unit_price'],
      periodStart: json['period_start'],
      periodEnd: json['period_end'],
      quantity: json['quantity'],
      quantityUnit: json['quantity_unit'] === 'no_unit' ? '' : json['quantity_unit'],
      vatExcludedTotal: json['vat_excluded_total'],
      vatRate: Number(json['vat_rate']),
      // TODO #API take only vat_included_total when this value will be available for all invoices
      // More info:
      // for standard invoices and for 'some' legacy invoices (loaded from SAP), vat_included_total is filled in
      // for nearly all legacy invoices, vat_excluded_total is filled in,
      // (there's currently a backend hack to store VAT included value in the vat_excluded column...)
      total: json['vat_included_total'] ? json['vat_included_total'] : json['vat_excluded_total'],
      vatIdentifier: json['vat_identifier'],
      label: this.invoiceLabelAdapter.get(json['label']),
      description: json['description'],
      sourceKey: json['source_key'],
      status: getInvoiceItemStatusFromValue(json['status']),
      statusComment: json['status_comment'],
      internalCode: json['internal_code'],
      externalCode: json['external_code'],
      regularizationId: json['regularization_id'],
    });
  }
}
